module.exports = __webpack_public_path__ + "media/4.256c9469.wav";